/* eslint-disable max-len */
/* eslint-disable no-param-reassign */

import {
  CHANGE_USER_STATUS_FAILURE,
  CHANGE_USER_STATUS_REQUEST,
  CHANGE_USER_STATUS_SUCCESS,
  CREATE_NEW_USER_FAILURE,
  CREATE_NEW_USER_REQUEST,
  CREATE_NEW_USER_SUCCESS,
  GET_ALL_PERMISSION_USERS_FAILURE,
  GET_ALL_PERMISSION_USERS_REQUEST,
  GET_ALL_PERMISSION_USERS_SUCCESS,
  UPDATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
} from 'settings/permissions/actions';

const initState = {
  isPosting: false,
  isFetching: false,
  isSaved: false,
  errorMessage: '',
  successMessage: '',
  users: [],
};

const permissionsReducer = (state = initState, action) => {
  if (action && action.type) {
    switch (action.type) {
      case GET_ALL_PERMISSION_USERS_REQUEST: {
        return { ...state, isFetching: true, errorMessage: '' };
      }
      case GET_ALL_PERMISSION_USERS_SUCCESS: {
        return { ...state, users: action.response, isFetching: false };
      }
      case GET_ALL_PERMISSION_USERS_FAILURE: {
        return { ...state, errorMessage: action.errorMessage, isFetching: false };
      }
      case CREATE_NEW_USER_REQUEST: {
        return { ...state, isPosting: true, isSaved: false, errorMessage: '', successMessage: '' };
      }
      case CREATE_NEW_USER_SUCCESS: {
        return { ...state, isPosting: false, isSaved: true, successMessage: 'The user is successfully created.' };
      }
      case CREATE_NEW_USER_FAILURE: {
        return { ...state, errorMessage: action.errorMessage, isPosting: false };
      }
      case UPDATE_USER_REQUEST: {
        return { ...state, isPosting: true, isSaved: false, errorMessage: '', successMessage: '' };
      }
      case UPDATE_USER_SUCCESS: {
        const users = state.users.map((user) => {
          if (user.id === action.response.id) {
            return action.response;
          }
          return user;
        });

        return { ...state, users, successMessage: 'The user is successfully updated.', isPosting: false };
      }
      case UPDATE_USER_FAILURE: {
        return { ...state, errorMessage: action.errorMessage, isPosting: false };
      }
      case CHANGE_USER_STATUS_REQUEST: {
        return {
          ...state,
          isPosting: true,
          isSaved: false,
          errorMessage: '',
          successMessage: '',
          errorDeleteUser: false,
        };
      }
      case CHANGE_USER_STATUS_SUCCESS: {
        if (action.params.action === 'delete') {
          const users = state.users.filter((user) => user.id !== action.params.id);
          return { ...state, users, isPosting: false, successMessage: 'The user is successfully deleted.' };
        }
        if (action.params.action === 'activate' || action.params.action === 'deactivate') {
          const users = state.users.map((user) => {
            if (user.id === action.params.id) {
              user.status = action.params.action === 'activate';
            }
            return user;
          });
          return {
            ...state,
            users,
            isPosting: false,
            successMessage: `The user is successfully ${action.params.action}d.`,
            errorDeleteUser: false,
          };
        }
        return state;
      }
      case CHANGE_USER_STATUS_FAILURE: {
        return { ...state, isPosting: false, errorDeleteUser: true };
      }
      default:
        return state;
    }
  }
  return state;
};

export default permissionsReducer;
